import React, { ReactNode } from 'react';
// Interfaces
import { IButtonStyles } from '../../../interfaces/config.interfaces';
// Config
import { ConfigContext } from '../../../providers';
// Styles
import styles from './button.module.scss';

interface IButtonProps {
    id?: string;
    children: ReactNode;
    onClick?: (event?: React.MouseEvent) => void;
    type?: 'button' | 'reset' | 'submit';
    variant?: 'primary' | 'secondary' | 'black';
    size?: string;
    disabled?: boolean;
    className?: string;
    ariaLabel?: string;
    link?: boolean;
}

export const Button = ({
    id,
    children,
    onClick,
    type = 'button',
    variant = 'primary',
    size = 'md',
    disabled = false,
    className = '',
    link,
    ariaLabel,
}: IButtonProps) => {
    const onLinkClick = (event: React.MouseEvent) => {
        const link = event.currentTarget.firstChild as HTMLLinkElement;
        link && link.click();
    };

    return (
        <ConfigContext.Consumer>
            {(config): JSX.Element => (
                <button
                    id={id}
                    type={type}
                    onClick={link ? onLinkClick : onClick}
                    disabled={disabled}
                    tabIndex={disabled ? -1 : 0}
                    style={config.colors.buttons[variant] ? generateButtonStyles(config.colors.buttons[variant]) : null}
                    className={generateBtnClasses(variant, size, disabled, link, className)}
                    {...(ariaLabel && { 'aria-label': ariaLabel })}
                >
                    {children}
                </button>
            )}
        </ConfigContext.Consumer>
    );
};

const generateButtonStyles = (buttonStyleConfigProperties: IButtonStyles) => {
    return {
        backgroundColor: buttonStyleConfigProperties.background,
        color: buttonStyleConfigProperties.color,
    };
};

// helper functions
const generateBtnClasses = (
    variant: string,
    size: string,
    disabled: boolean,
    link: boolean,
    className: string
): string => {
    const classNames = [styles.button, styles[size], styles[variant]];

    if (disabled) classNames.push(styles.disabled);
    if (className) classNames.push(className);
    if (link) classNames.push([styles.link, 'p-0'].join(' '));

    return classNames.join(' ');
};
